export default __webpack_public_path__ + "static/media/IMG-20240729-WA0031.d4cf6320.jpg";